import * as React from "react";
import { Flex, Spinner } from "@chakra-ui/react";
import { Navigate, Route, Routes } from "react-router-dom";
import { useAuth, useOnline } from "duck";
import * as Pages from "pages";
import { UserRoleEnum } from "requests";
import { Layout, LoginLayout } from "./components";

const AppRouter: React.FC = () => {
  const [{ loading, user }] = useAuth();
  const online = useOnline();

  if (loading) {
    return (
      <Flex
        h="100vh"
        backgroundColor="gray.50"
        justifyContent="center"
        alignItems="center"
      >
        <Spinner />
      </Flex>
    );
  }

  return (
    <Routes>
      {user ? (
        <>
          <Route path="graphiql" element={<Pages.GraphiQL />} />
          <Route path="/*" element={<Layout />}>
            {user.userRole === UserRoleEnum.RoleSuperAdmin ? (
              <>
                <Route
                  path="organization-management/*"
                  element={<Pages.AdminOrganizationManagement />}
                />
                <Route
                  path="license-management/*"
                  element={<Pages.LicenseManagement />}
                />
                <Route path="access-logs/*" element={<Pages.AccessLogs />} />
                <Route
                  path="order-management/*"
                  element={<Pages.OrderManagement />}
                />
                <Route path="email-logs/*" element={<Pages.EmailLogs />} />
                <Route path="reports/*" element={<Pages.Reports />} />

                <Route
                  path="*"
                  element={<Navigate to="organization-management" />}
                />
              </>
            ) : (
              <>
                <Route path="cases/" element={<Pages.Cases />} />
                <Route path="cases/:id/*" element={<Pages.Case />} />
                <Route
                  path="anesthetic-protocols"
                  element={<Pages.AnestheticProtocols />}
                />
                <Route
                  path="anesthetic-protocols/:id"
                  element={<Pages.AnestheticProtocol />}
                />
                {online &&
                  user.userRole !== UserRoleEnum.RoleOrganizationAdmin && (
                    <Route path="profile/*" element={<Pages.UserProfile />} />
                  )}
                {online &&
                  user.userRole === UserRoleEnum.RoleOrganizationAdmin && (
                    <Route
                      path="organization-management/*"
                      element={<Pages.OrganizationManagement />}
                    />
                  )}
                {online &&
                  user.userRole === UserRoleEnum.RoleOrganizationAdmin && (
                    <Route path="settings/*" element={<Pages.Settings />} />
                  )}
                <Route path="*" element={<Navigate to="cases" />} />
              </>
            )}
          </Route>
        </>
      ) : (
        <Route path="*" element={<LoginLayout />}>
          <Route
            path="password-recovery/:id"
            element={<Pages.ChangePassword />}
          />
          <Route
            path="registration-completion/:id"
            element={<Pages.CompleteRegistration />}
          />
          <Route
            path="password-recovery"
            element={<Pages.PasswordRecovery />}
          />
          <Route path="login" element={<Pages.Login />} />
          {!online && <Route path="pin" element={<Pages.Pin />} />}
          <Route
            path="*"
            element={<Navigate to={online ? "login" : "pin"} />}
          />
        </Route>
      )}
    </Routes>
  );
};

export default React.memo(AppRouter);
